import React from "react";

function Tabs({ tabs = [], activeId, onChange, className = "" }) {
  const classes = ["ui-tabs", className].filter(Boolean).join(" ");

  return (
    <div className={classes} role="tablist">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={tab.id === activeId}
          className={`ui-tabs__tab${tab.id === activeId ? " is-active" : ""}`}
          onClick={() => onChange && onChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}

export default Tabs;
